import $ from 'jquery';
import Tooltip from 'tether-tooltip';

import Tabs from './modules/tabs';
import Accordions from './modules/accordions';
import PasswordStrengthMeter from './modules/password-strength-meter';
import RGT from './modules/radio-group-toggle';

$(() => {
  Tabs.init();
  Accordions.init();

  const tooltips = $('[data-zva-tooltip]').map((index, tooltip) => {
    //console.log('tootltip', tooltip);
    return new Tooltip({
      target: tooltip,
      position: 'bottom right',
      content: $(tooltip).attr('data-zva-tooltip'),
      classes: 'tooltip-theme-zva'
    });
  });

  RGT.create({
    observeContext: '.c-zva-registration-content',
    observeInputs: '[name="hat-knr"]',
    valueTargetMap: {
      0: '#hat-knr-nein',
      1: '#hat-knr-ja'
    }
  });

  PasswordStrengthMeter.create({
    input: '#password',
    meter: '#password-strength-meter'
  });
});



// WEBPACK FOOTER //
// ./main.js